import bfbTheme from './b4b-theme';
import a11yOverrides from './b4b-theme-a11y';

const getAntTheme = (highContrast = false) => {
  const colors = highContrast ? { ...bfbTheme, ...a11yOverrides } : bfbTheme;

  return ({
  token: {
    // Seed token (general)
    borderRadius: 4,
    colorError: colors.error,
    colorInfo: colors.hyperlink,
    colorLink: colors.hyperlink,
    colorPrimary: colors.mainColor,
    colorSuccess: colors.teal,
    colorWarning: colors.warning,
    controlHeight: 35,
    fontSize: 15,
    fontFamily: '"Source Sans 3", "Roboto", sans-serif',

    // Map token (modifyers)
    colorPrimaryHover: colors.mainColor, // input border color on hover
    colorTextTertiary: colors.grey,
    lineHeight: 1.666667,
    fontSizeHeading1: 24,
    fontSizeHeading2: 22,
    fontSizeHeading3: 20,
    fontSizeHeading4: 20,

    // Alias (specific elements)
    colorIconHover: colors.teal, // icons inside inputs
    colorTextPlaceholder: colors.grey,
    colorBgSpotlight: 'white', // This is currently only used in the background color of Tooltip.
    controlItemBgHover: colors.tealFade, // hover background color of dropdown items
  },
  // Table Global Styles
  components: {
    Form: {
      itemMarginBottom: 6,
    },
    Menu: {
      itemActiveBg: colors.tealFade,
      itemSelectedBg: colors.tealFade,
      itemHoverBg: colors.tealFade,
    },
    Table: {
      cellFontSize: 15,
      rowHoverBg: '#EBFEF7',
      rowSelectedBg: '#EBFEF7',
      rowSelectedHoverBg: '#EBFEF7',
    },
    Slider: {
      dotSize: 14,
      railSize: 8,
      handleSize: 18,
      handleSizeHover: 18,
      handleLineWidth: 3,
      handleLineWidthHover: 3,
    },
  },
});
};

export { getAntTheme };
